import { Link } from "react-router-dom";
import { useState } from "react";
import "./Sidebar.css";

export default function Sidebar() {
    const [open, setOpen] = useState(false);

    return (
        <>
            {/* BOUTON BURGER (visible uniquement sur mobile) */}
            <div className="burger" onClick={() => setOpen(!open)}>
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>

            {/* MENU LATERAL */}
            <div className={`sidebar ${open ? "open" : ""}`}>
                <h2>Nina et Sam</h2>
                <ul>
                    <li><Link to="/invitation" onClick={() => setOpen(false)}>Mariage participatif</Link></li>
                    <li><Link to="/menu-bar" onClick={() => setOpen(false)}>Côté cour</Link></li>
                    <li><Link to="/activites" onClick={() => setOpen(false)}>Avant-scène</Link></li>
                    <li><Link to="/boutchou" onClick={() => setOpen(false)}>Côté jardin</Link></li>
                    <br/>
                    <br/>
                    <li><Link to="/infos" onClick={() => setOpen(false)}>Infos pratiques</Link></li>
                    <li><Link to="/contribution" onClick={() => setOpen(false)}>Votre contribution</Link></li>
                    <li><Link to="/playlist" onClick={() => setOpen(false)}>Playlist</Link></li>
                    <li><Link to="/photos" onClick={() => setOpen(false)}>Team + Photos</Link></li>
                    <li><Link to="/civil" onClick={() => setOpen(false)}>Mariage civil</Link></li>
                    {/* <li><Link to="/faq" onClick={() => setOpen(false)}>Foire aux questions</Link></li> */}
                    <li><Link to="/urne" onClick={() => setOpen(false)}>Urne virtuelle</Link></li>
                </ul>
            </div>
        </>
    );
}

